import _orderBy from 'lodash/orderBy';

import { LedgerAccountEvent } from 'models';
import { GetRequestParams } from './types';

export function buildRequestSearchParams(params: GetRequestParams) {
  const { endDate, selectedBankAccountsIds, startDate } = params;
  const searchParams = new URLSearchParams();

  for (let bankAccountId of selectedBankAccountsIds) {
    searchParams.append('bankAccountId', bankAccountId);
  }

  searchParams.append('startDate', startDate);
  searchParams.append('endDate', endDate);

  return searchParams.toString();
}

export function processLedgerAccountEvents(
  ledgerAccountEvents: LedgerAccountEvent[]
) {
  const filteredLedgerAccountEvents = ledgerAccountEvents.filter(
    (ledgerAccountEvent) => ledgerAccountEvent.LedgerAccountNumber !== '2900'
  );

  return _orderBy(
    filteredLedgerAccountEvents,
    ({ LedgerAccountNumber }) => Number(LedgerAccountNumber),
    'asc'
  );
}
